export default "__VITE_ASSET__CrcfMT0b__";